export default "__VITE_ASSET__bi0Gfxw8__"